import React from 'react';
import { TableBooleanColumnTemplate } from 'themes/components';

function TableBooleanColumn(props) {
    return (
        <TableBooleanColumnTemplate {...props} />
    )
}

export default TableBooleanColumn;